import React, {Component} from "react";
import {connect} from "react-redux";
import Table from "../../../components/Table";
import ProductItem from "./ProductItem";
import Loading from "../../../components/Loading";
import GraphQLErrors from "../../../components/GraphQLErrors";
import {fromJS, List, Set} from "immutable";
import {graphql} from "react-apollo";
import {LIST_SHOP_SUBSCRIPTION_PRODUCTS, ON_UPDATED_SHOP_SUBSCRIPTION_PRODUCT, ON_UPDATED_SHOP_SUBSCRIPTION_PRODUCTS} from "../../../queries/inventory";
import "./SubscriptionProductsList.css";

function getItemKey(shopId, item) {
  return composeId(shopId, item.get("productSku"), item.get("version"));
}

function composeId(shopId, productSku, version) {
  return `${shopId}-${productSku}-${version}`;
}

class SubscriptionProductsList extends Component {

  constructor(props) {
    super(props);
    this.state = {
      selectedVersion: false,
      version: ""
    }
  }

  UNSAFE_componentWillMount() {
    this.unsubscribeToSubscriptionProductUpdates = this.props.subscribeToSubscriptionProductUpdates(this.props, {}); 
    this.unsubscribeToAllSubscriptionProductUpdates = this.props.subscribeToAllSubscriptionProductUpdates(this.props, {}); 
  }

  componentWillUnmount() {
    if (this.unsubscribeToSubscriptionProductUpdates) {
      this.unsubscribeToSubscriptionProductUpdates();
    }
    if (this.unsubscribeToAllSubscriptionProductUpdates) {
      this.unsubscribeToAllSubscriptionProductUpdates();
    }
  }  

  render() {
    let {loading, error, shopSubscriptionProducts, shop} = this.props.data;
    if (loading) return <Loading />
    if (error) return <GraphQLErrors error={error} />

    let tableHeader = List([
      "SKU",
      "Title",
      "Price"
    ])

    let products = fromJS(shopSubscriptionProducts);
    let version = (this.state.selectedVersion === true) ? this.state.version : shop.subscriptionPricelistVersion;

    // Filter products
    let filteredProducts = products.filter((item) => {
      return item.get("version") === version;
    })

    // Get options.
    let options = 
      products
      .reduce((acc, prod) => {
        return acc.add(prod.get("version"));
      }, Set())
      .toList()
      .map((val) => {
        if (val === shop.subscriptionPricelistVersion) {
          return <option key={val} value={val}>{val} (current)</option>
        } else {
          return <option key={val} value={val}>{val}</option>
        }
      })
      .toArray();

    return (
      <React.Fragment>
        <div className="title">
          <h5>Subscription Pricing</h5>
          <select value={version} onChange={this.handleChangeVersion.bind(this)}>
            {options}
          </select>
        </div>
        <Table 
          data={filteredProducts} 
          renderer={ProductItem} 
          mode="table"
          tableHeader={tableHeader}
          selected={composeId(this.props.shopId, this.props.selectedProductId, shop.subscriptionPricelistVersion)}
          onItemClick={this.handleItemClick.bind(this)}
          getItemKey={(itemData) => getItemKey(this.props.shopId, itemData)}
          />
      </React.Fragment>
    )
  }

  handleChangeVersion(e) {
    this.setState({
      selectedVersion: true,
      version: e.currentTarget.value
    })
  }

  handleItemClick(itemData, e) {
    let id = itemData.get("productSku");
    this.props.onSelectionChange(id, itemData.get("shopId"));
  }  
}

const withQuery = graphql(LIST_SHOP_SUBSCRIPTION_PRODUCTS, {
  options: (props) => ({
    fetchPolicy: "network-only",
    variables: {
      shopId: props.shopId,
      version: "all"
    }    
  })
})

const mapDispatchToProps = dispatch => ({
  subscribeToSubscriptionProductUpdates: (props, params) => {
    return props.data.subscribeToMore({
      document: ON_UPDATED_SHOP_SUBSCRIPTION_PRODUCT,
      updateQuery: (prev, { subscriptionData }) => {
        if (!subscriptionData.data) {
          return prev;
        }
        return {
          shopSubscriptionProduct: subscriptionData.data.updatedShopSubscriptionProduct
        }
      }
    })
  },
  subscribeToAllSubscriptionProductUpdates: (props, params) => {
    return props.data.subscribeToMore({
      document: ON_UPDATED_SHOP_SUBSCRIPTION_PRODUCTS,
      variables: {
        shopId: props.shopId
      },
      updateQuery: (prev, { subscriptionData }) => {
        props.data.refetch();
        return prev;
      }
    })
  }  
})

export default connect(null, mapDispatchToProps)(withQuery(SubscriptionProductsList));